export default "__VITE_ASSET__cj4vm7zM__"